<div
    [ngClass]="{
        'w-100': !viewportService.isLargeViewPort(),
        'partial-height-mobile': partialHeight(),
        'full-height-mobile': !partialHeight(),
        'h-100 width-400px': viewportService.isLargeViewPort()
    }"
    class="position-absolute overflow-x-hidden background-white z-max">
    <div [ngClass]="{'w-100': !viewportService.isLargeViewPort(), 'width-400px': viewportService.isLargeViewPort()}"
         class="row position-fixed background-light-gray border-bottom border-dark-subtle p-3 m-0 z-max d-flex align-items-center height-details-header">
        <div (click)="back()"
             class="col-1 pt-4 pb-4 btn text-reset m-auto rounded-2"
             type="button">
            <i class="fa-solid fa-chevron-left color-secondary-information"></i>
        </div>
        <div class="col-2 m-0 d-flex justify-content-center m-auto" type="button">
            <app-animal-profile-picture [animal]="animal()" (click)="showProfilePictureModal()" [clickable]="true" [alter]="true"/>
        </div>
        <div class="col-8 m-0 m-auto">
            <div class="fw-bold color-secondary-information text-truncate">{{ animal()?.visualTag || '-' }}</div>
            <app-animal-status-bar [animal]="animal()"/>
            <app-animal-details-bar [animal]="animal()"
                                    [showBatteryLevel]="true"/>
        </div>
        <div (click)="close()"
             class="col-1 pt-4 pb-4 btn text-reset m-auto rounded-2"
             type="button">
            <i class="fa-solid fa-x color-secondary-information"></i>
        </div>
    </div>
    <div class="flex-grow-1 margin-top-details-header ps-3 pe-3 pb-3">
        <ng-content/>
    </div>
</div>

@if (profilePictureModalIsVisible()) {
    <div class="profile-picture-modal" (click)="dismissProfilePictureModal()">
        <i class="fa-solid fa-x close-modal"></i>
        <img class="profile-picture" [src]="animal()?.profilePictureUrl" (click)="$event.stopPropagation()"/>
    </div>
}
